import { useEffect } from 'react';
import { type TTFontWithFileDTO } from '@/model';

// Loads the given custom fonts into the browser via the FontFace API so they
// actually render (e.g. in the rich text editor's font family select).
export const useRegisterCustomFontFaces = (fonts: TTFontWithFileDTO[]): void => {
  useEffect(() => {
    fonts.forEach((font) => {
      if (!font.file) {
        return;
      }

      new FontFace(font.name, `url(data:font/ttf;base64,${font.file})`)
        .load()
        .then((loadedFace) => {
          document.fonts.add(loadedFace);
        })
        .catch();
    });
  }, [fonts]);
};
